import React, { useContext } from "react";
import ReactDOM from "react-dom";
import { LoadingContext } from "../../contexts/loadingContext";
import '../../assets/styles/loading_overlay.scss';
import { Spinner } from "../icons";

// loading overlay
const LoadingOverlay = ({ color }) => {
  let { loadingComponent } = useContext(LoadingContext);
  if (loadingComponent) {
    return ReactDOM.createPortal(
      <>
        <div className="loading">
            {/* <img className="loader-spinner" alt="spinner" src={Images.spinner} /> */}
            <Spinner color={color} />
        </div>
      </>
      ,document.querySelector("#loading-root")
    );
  } else return null;
};

export default LoadingOverlay;